import { Route } from 'react-router-dom';
import ClientsListPage from './pages/ClientsListPage';
import RegisterClientPage from './pages/RegisterClientPage';
import RechargePointsPage from './pages/RechargePointsPage';
import BestClientsPage from './pages/BestClientsPage';
import ClientHistoryPage from './pages/ClientHistoryPage';
import InactiveClientsPage from './pages/InactiveClientsPage';
import LatestVisitsPage from './pages/LatestVisitsPage';
import BirthdayPanel from './pages/BirthdayPanel';
import LatestRegistrationsPage from './pages/LatestRegistrationsPage';
import UnsatisfiedClientsPage from './pages/UnsatisfiedClientsPage';
import ReferralsPage from './pages/ReferralsPage';
import TagManagerPage from './pages/TagManagerPage';  // ✅ NUEVO
import CheckinApprovalsPage from './pages/CheckinApprovalsPage';  // registro por QR (F1)
import CardScanPage from './pages/CardScanPage';  // tarjeta QR del cliente + escáner (23-oct-2026)

export const ClientRoutes = [
  <Route key="clients-list" path="/dashboard/clients" element={<ClientsListPage />} />,
  <Route key="checkin-approvals" path="/dashboard/checkin-approvals" element={<CheckinApprovalsPage />} />,
  <Route key="card-scan" path="/dashboard/card-scan" element={<CardScanPage />} />,
  <Route key="register-client" path="/dashboard/register-client" element={<RegisterClientPage />} />,
  <Route key="birthday-panel" path="/dashboard/birthday-panel" element={<BirthdayPanel />} />,
  <Route key="recharge-points" path="/dashboard/recharge-points" element={<RechargePointsPage />} />,
  <Route key="best-clients" path="/dashboard/best-clients" element={<BestClientsPage />} />,
  <Route key="client-history" path="/dashboard/clients/:clientId/history" element={<ClientHistoryPage />} />,
  <Route key="inactive-clients" path="/dashboard/inactive-clients" element={<InactiveClientsPage />} />,
  <Route key="latest-visits" path="/dashboard/latest-visits" element={<LatestVisitsPage />} />,
  <Route key="latest-registrations" path="/dashboard/latest-registrations" element={<LatestRegistrationsPage />} />,
  <Route key="unsatisfied-clients" path="/dashboard/unsatisfied-clients" element={<UnsatisfiedClientsPage />} />,
  <Route key="referrals" path="/dashboard/referrals" element={<ReferralsPage />} />,
  <Route key="tag-manager" path="/dashboard/tags" element={<TagManagerPage />} />,  // ✅ NUEVO
];